var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Card, Button, Table } from 'antd';
import React, { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Bar } from 'react-chartjs-2';
import SalesPeriodFilter from '../../dashboard/components/filter/line-chart-filter';
import { fetchReviewSatisfaction, fetchReviewSatisfactionDetail } from '../../cores/api/api-dashboard';
import { LABEL_MAP_REVIEW } from '../../contants/option';
import { formatCountNumber } from '../../utils/format-data';
export const ReviewAverageCard = () => {
    const now = new Date();
    const _useState = useState('chart'), _useState2 = _slicedToArray(_useState, 2), viewMode = _useState2[0], setViewMode = _useState2[1];
    const _useState3 = useState({
        mode: 'year',
        year: now.getFullYear(),
        month: now.getMonth() + 1
    }), _useState4 = _slicedToArray(_useState3, 2), filters = _useState4[0], setFilters = _useState4[1];
    const _useQuery = useQuery({
        queryKey: ['review-average', filters],
        suspense: true,
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            if (filters.mode === 'month' && filters.month) {
                return yield fetchReviewSatisfactionDetail({
                    year: filters.year,
                    month: filters.month
                });
            }
            if (filters.mode === 'range' && filters.year_from != null && filters.year_to != null) {
                return yield fetchReviewSatisfaction({
                    year_from: filters.year_from,
                    year_to: filters.year_to
                });
            }
            return yield fetchReviewSatisfaction({
                year: filters.year
            });
        })
    }), data = _useQuery.data;
    const handleFilterChange = value => {
        setFilters(value);
    };
    const forms = useMemo(() => {
        if (!data)
            return [];
        const map = {};
        data.data.forEach(day => {
            day.items.forEach(item => {
                if (!map[item.key]) {
                    map[item.key] = {
                        key: item.key,
                        star_1: 0,
                        star_2: 0,
                        star_3: 0,
                        star_4: 0
                    };
                }
                map[item.key].star_1 += item.star_1;
                map[item.key].star_2 += item.star_2;
                map[item.key].star_3 += item.star_3;
                map[item.key].star_4 += item.star_4;
            });
        });
        return Object.values(map);
    }, [data]);
    const percentData = useMemo(() => {
        return forms.map(f => {
            const total = f.star_1 + f.star_2 + f.star_3 + f.star_4;
            if (!total) {
                return {
                    key: f.key,
                    label: LABEL_MAP_REVIEW[f.key] || f.key,
                    star1: 0,
                    star2: 0,
                    star3: 0,
                    star4: 0
                };
            }
            return {
                key: f.key,
                label: LABEL_MAP_REVIEW[f.key] || f.key,
                star1: Number((f.star_1 / total * 100).toFixed(1)),
                star2: Number((f.star_2 / total * 100).toFixed(1)),
                star3: Number((f.star_3 / total * 100).toFixed(1)),
                star4: Number((f.star_4 / total * 100).toFixed(1))
            };
        });
    }, [forms]);
    const tableData = useMemo(() => {
        if (!forms.length)
            return [];
        const toPercent = f => {
            const total = f.star_1 + f.star_2 + f.star_3 + f.star_4;
            if (!total)
                return [0, 0, 0, 0];
            return [f.star_1 / total * 100, f.star_2 / total * 100, f.star_3 / total * 100, f.star_4 / total * 100];
        };
        const stars = ['⭐', '⭐⭐', '⭐⭐⭐', '⭐⭐⭐⭐'];
        return stars.map((star, starIndex) => {
            const row = {
                key: star,
                star
            };
            forms.forEach(f => {
                const label = LABEL_MAP_REVIEW[f.key] || f.key;
                row[label] = `${toPercent(f)[starIndex].toFixed(1)}%`;
            });
            return row;
        });
    }, [forms]);
    const chartData = {
        labels: percentData.map(i => i.label),
        datasets: [{
                label: '⭐',
                data: percentData.map(i => i.star1),
                backgroundColor: '#ff4d4f'
            }, {
                label: '⭐⭐',
                data: percentData.map(i => i.star2),
                backgroundColor: '#ffa940'
            }, {
                label: '⭐⭐⭐',
                data: percentData.map(i => i.star3),
                backgroundColor: '#fadb14'
            }, {
                label: '⭐⭐⭐⭐',
                data: percentData.map(i => i.star4),
                backgroundColor: '#73d13d'
            }]
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                max: 100
            },
            y: {
                stacked: true,
                min: 0,
                max: 100,
                ticks: {
                    callback: value => `${value}%`
                }
            }
        }
    };
    const columns = useMemo(() => {
        if (!forms.length)
            return [];
        const dynamicColumns = forms.map(f => ({
            title: LABEL_MAP_REVIEW[f.key] || f.key,
            dataIndex: LABEL_MAP_REVIEW[f.key] || f.key,
            align: 'center'
        }));
        return [{
                title: '評価',
                dataIndex: 'star',
                fixed: 'left',
                width: 80
            }, ...dynamicColumns];
    }, [forms]);
    const total = useMemo(() => forms.reduce((sum, f) => sum + f.star_1 + f.star_2 + f.star_3 + f.star_4, 0), [forms]);
    return /*#__PURE__*/ React.createElement(Card, {
        title: /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center gap-3"
        }, /*#__PURE__*/ React.createElement("span", null, "\u30EC\u30D3\u30E5\u30FC\u6E80\u8DB3\u5EA6\u5206\u5E03"), /*#__PURE__*/ React.createElement("span", {
            className: "text-sm font-normal text-gray-500"
        }, "Total: ", formatCountNumber(total))),
        extra: /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center gap-4"
        }, /*#__PURE__*/ React.createElement(SalesPeriodFilter, {
            enableYearRange: true,
            onChange: handleFilterChange
        }), /*#__PURE__*/ React.createElement("div", {
            className: "flex gap-2"
        }, /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('chart'),
            className: viewMode === 'chart' ? '!bg-[#f0c52a36]' : ''
        }, "\u30B0\u30E9\u30D5"), /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('table'),
            className: viewMode === 'table' ? '!bg-[#f0c52a36]' : ''
        }, "\u8868"))),
        styles: {
            body: {
                height: 400
            }
        }
    }, viewMode === 'chart' ? /*#__PURE__*/ React.createElement("div", {
        style: {
            height: 350
        }
    }, /*#__PURE__*/ React.createElement(Bar, {
        data: chartData,
        options: options
    })) : /*#__PURE__*/ React.createElement(Table, {
        rowKey: "key",
        columns: columns,
        dataSource: tableData,
        pagination: false,
        scroll: {
            x: true,
            y: 350
        },
        locale: {
            emptyText: 'データがありません'
        }
    }));
};
